// core version + navigation, pagination modules:
import Swiper, { Pagination, Navigation } from 'swiper';
// swiper core styles
import 'swiper/css/bundle';

import './testimonials-carousel.scss';

class testimonialsCarousel {

    constructor(el) {
        this.el = el;
        this.wrapper = el.querySelector('.swiper');
        this.prevBtn = el.querySelector('.swiper-prev-btn');
        this.nextBtn = el.querySelector('.swiper-next-btn');
        if(this.wrapper != null) {
            // layout mode?
            if(this.el.classList.contains('testimonials-carousel--multiple')) {
                // multiple layout mode
                this.swiper = new Swiper(this.wrapper, {
                    // Optional parameters
                    modules: [Pagination, Navigation],
                    slidesPerView: 1,
                    centeredSlides: false,
                    loop: true,
                    spaceBetween: 30,
                    breakpoints: {
                        // when window width is >= 'md'
                        768: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 'lg'
                        992: {
                            slidesPerView: 3,
                        }
                    },
                    // Pagination
                    pagination: {
                      el: el.querySelector('.swiper-pagination'),
                      clickable: true,
                    },
                    // Navigation arrows
                    navigation: {
                      prevEl: this.prevBtn,
                      nextEl: this.nextBtn
                    },
                });
            } else {
                // single layout mode
                this.swiper = new Swiper(this.wrapper, {
                    // Optional parameters
                    modules: [Pagination, Navigation],
                    slidesPerView: 1,
                    centeredSlides: false,
                    loop: true,
                    // Pagination
                    pagination: {
                      el: el.querySelector('.swiper-pagination'),
                      clickable: true,
                    },
                    // Navigation arrows
                    navigation: {
                      prevEl: this.prevBtn,
                      nextEl: this.nextBtn
                    },
                });
            }
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {

    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new testimonialsCarousel(node);
        }
    });

}
